import '../../App.css';
import React, { useContext, useRef, useState } from "react";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes, FaPlus, FaImage } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalCadastrarPratica({ closeModal, currentPage }) {
    const { CadastrarPratica, CadastroPratica, setCadastroPratica, FormAnexo, setFormAnexo, setError } = useContext(ServicoContext)
    const { btnVer, btnCriar, btnPesquisar } = useContext(StyleContext)
    const anexoRef = useRef()

    const [AddAnexo, setAddAnexo] = useState('')
    const [attLista, setattLista] = useState(false)

    const handleChange = (event) => {
        setCadastroPratica({ ...CadastroPratica, [event.target.name]: event.target.value })
    }

    const AdicionarAnexo = () => {
        if (!AddAnexo) {
            setError("Campo anexo em branco.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(AddAnexo);
        reader.onloadend = () => {
            let data = {
                file: reader.result.split(',')[1],
                fileName: AddAnexo.name,
                contentType: AddAnexo.type
            };

            setFormAnexo(FormAnexo => [...FormAnexo, data]);
            setAddAnexo(null);
            anexoRef.current.value = ""
            setattLista(!attLista);
        };
    };

    const ExcluirAnexo = (props) => {
        FormAnexo.splice(props, 1)
        setattLista(!attLista)
    }

    const handleClose = () => {
        closeModal(false)
        setCadastroPratica({nome: "", descricao: ""});
        setFormAnexo([])
    }

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar prática de referência</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarPratica(e, currentPage)}>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control maxLength={255} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div>
                            <Form.Group className="mb-3">
                                <Form.Label>Anexos</Form.Label>
                                <Form.Control type='file' onChange={(e) => setAddAnexo(e.target.files[0])} name="anexo" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt" ref={anexoRef} />
                            </Form.Group>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <button className="btn-dash btn-pesquisar" style={btnPesquisar} type="button" onClick={() => AdicionarAnexo()}><FaPlus style={{ marginRight: "5px" }} />Adicionar</button>
                            </div>
                            <div style={{ display: 'flex', gap: '35px', flexWrap: 'wrap', maxHeight: '300px', overflow: 'auto' }} className="mb-3">
                                {FormAnexo && FormAnexo?.map((item, index) => {
                                    return (
                                        <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '180px' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <FaImage style={{ fontSize: '40px' }} />
                                                <span style={{ wordBreak: 'break-word' }}>{item.fileName}</span>
                                            </div>
                                            <div className="div-button">
                                                <button type="button" className="btn-del" onClick={() => ExcluirAnexo(index)}><TbTrash /></button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarPratica